import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      initialized: false,
      currentRequest: null,

      initialize: () => {
        const token = get().token;
        if (token) {
          get().fetchUser();
        } else {
          set({ initialized: true });
        }
      },

      setRequest: (request) => {
        set({ currentRequest: request });
      },

      fetchUser: async () => {
        try {
          const response = await api.get('/auth/me');
          set({
            user: response.data.user,
            isAuthenticated: true,
            initialized: true
          });
        } catch (error) {
          set({
            user: null,
            token: null,
            isAuthenticated: false,
            initialized: true
          });
        }
      },

      loginWithOTP: async (email, otp, firstName, lastName) => {
        try {
          const response = await api.post('/auth/otp/verify', {
            email,
            otp,
            firstName,
            lastName
          });
          
          const { token, user } = response.data;
          
          set({
            token,
            user,
            isAuthenticated: true
          });
          
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          
          return { success: true };
        } catch (error) {
          return {
            success: false,
            error: error.response?.data?.error?.message || 'Login failed'
          };
        }
      },

      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          currentRequest: null
        });
        delete api.defaults.headers.common['Authorization'];
      },
    }),
    {
      name: 'acquiva-mobile-auth',
      partialize: (state) => ({ token: state.token, user: state.user })
    }
  )
);

// Initialize auth header
const storedToken = JSON.parse(localStorage.getItem('acquiva-mobile-auth'))?.state?.token;
if (storedToken) {
  api.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
}
